import { match } from 'ts-pattern'

import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const dental_underwriting = (params: StepConfigParams, plaform: 'native' | 'web') => {
  const nextStep = match(plaform)
    .with('native', () => 'dental_consent')
    .otherwise(() => 'payment_legal')

  return {
    stepContent: [
      {
        type: 'spinner',
      },
    ],
    isAutoSubmitStep: true,
    onPrepare: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'underwritingValidation',
        inputs: [],
        outputs: [],
      },
    },
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: 'helperValues.isUnderwritingValidationValid',
      valueToStepName: {
        false: 'failure',
        failure: 'failure',
        true: nextStep,
      },
    },
  } as const satisfies AnyStepConfiguration
}

export default dental_underwriting
